import { useEffect, useMemo, useState } from "react";

import { ensureCsrfToken, getLegacyUrl } from "../../api";


import { useRef, useEffect } from "react";

import Swal from "sweetalert2";

import CheckerViewShell from "./CheckerViewShell";

function formatDate(value) {
  if (!value) {
    return "-";
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return value;
  }

  return parsed.toLocaleDateString();
}

export default function CheckerNoMigoView() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [actionKey, setActionKey] = useState("");
  const [status, setStatus] = useState("");
  const [error, setError] = useState("");
  const [menuPosition, setMenuPosition] = useState(null);
  const [approvalModal, setApprovalModal] = useState({
    open: false,
    row: null,
    approvalData: {}
});

  const summary = useMemo(
    () => ({
      count: rows.length,
      updatedInvoices: rows.filter((row) => row.checker_approval?.["Updated InvNumber"]).length,
      updatedGst: rows.filter((row) => row.checker_approval?.["Updated VendorGST"]).length,
    }),
    [rows],
  );

  const menuRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target)
      ) {
        setMenuPosition(null);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener(
        "mousedown",
        handleClickOutside
      );
    };
  }, []);

  async function loadRows() {
    setLoading(true);
    setError("");

    try {
      const csrfToken = await ensureCsrfToken();
      const response = await fetch("/api/get-InvoiceNumberChange-pending/", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": csrfToken,
        },
      });

      const isJson = response.headers.get("content-type")?.includes("application/json");
      const payload = isJson ? await response.json() : null;

      if (!response.ok || !payload?.success) {
        throw new Error(payload?.message || "Unable to load checker Not found in MIGO approvals.");
      }

      setRows(payload.data || []);
    } catch (requestError) {
      setError(requestError.message || "Unable to load checker Not found in MIGO approvals.");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadRows();
  }, []);

  async function handleAction(approvalModal, type) {
    setStatus("");
    setError("");
    setActionKey(`${type}-${ approvalModal.row.InvoiceGroupKey}`);

    try {
      const csrfToken = await ensureCsrfToken();
      const endpoint = type === "approve" ? "/api/approve-InvoicenNum-Change/" : "/api/reject-InvoicenNum-Change/";
      const response = await fetch(endpoint, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": csrfToken,
        },
        body: JSON.stringify({
            invoice_group_key: approvalModal.row.InvoiceGroupKey,
            checker_approval: approvalModal.approvalData
        }),
      });

      const isJson = response.headers.get("content-type")?.includes("application/json");
      const payload = isJson ? await response.json() : null;

      if (!response.ok || payload?.status !== "success") {
        throw new Error(payload?.message || `Unable to ${type} invoice.`);
      }

      setStatus(payload.message || `Invoice ${type}d successfully.`);
      await loadRows();
    } catch (requestError) {
      setError(requestError.message || `Unable to ${type} invoice.`);
    } finally {
      setActionKey("");
    }
  }

  function openLegacyNoMigoPage() {
    window.localStorage.setItem("activeApprovalSection", "other_approvals");
    window.open(getLegacyUrl("/checker-dashboard/"), "_blank", "noreferrer");
  }

  function refreshPendingActions() {
    loadRows();
  }

  return (
    <CheckerViewShell
          title="Invoice Number/ Gst Number Change Approvals"
          intro="Review invoice-number and vendor-GST updates that need checker approval before the invoice
                returns to processing"
          metrics={[
            { label: "Queue", value: summary.count },
            
          ]}
          actions={
            <button
              className="ghost-button processor-view__refresh"
              type="button"
              onClick={refreshPendingActions}
            >
              Refresh
            </button>
          }
        >
        <section className="processor-view">
          

          {status ? <div className="config-banner config-banner--success">{status}</div> : null}
          {error ? <div className="config-banner config-banner--error">{error}</div> : null}

          

          <div className="workspace-panel">
            

            {loading ? (
              <p className="config-note">Loading checker MIGO approvals…</p>
            ) : (
              <div className="config-table processor-table">
                <table>
                  <thead>
                    <tr>
                      <th>Invoice ID</th>
                      <th>Vendor Name</th>
                      <th>Invoice No</th>
                      <th>Invoice Date</th>
                      <th>File</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.length ? (
                      rows.map((row) => (
                        <tr key={row.InvoiceGroupKey}>
                          <td>{row.InvoiceId}</td>
                          <td>{row.VendorName || "-"}</td>
                          <td>{row.InvNo || "-"}</td>
                          <td>{formatDate(row.InvDate)}</td>
                          
                          <td>
                            {row.InvoiceId ? (
                              <a
                                href={getLegacyUrl(`/api/invoice/view/${row.InvoiceId}/`)}
                                target="_blank"
                                rel="noreferrer"
                              >
                                PDF
                              </a>
                            ) : (
                              "-"
                            )}
                          </td>
                          <td>
                            <button
                                className="btn btn-primary btn-sm"
                                onClick={() =>
                                    setApprovalModal({
                                        open: true,
                                        row,
                                        approvalData: structuredClone(row.checker_approval || {})
                                    })
                                }
                            >
                                Approvals
                            </button>
                          </td>
                          {/* <td>
                            <div className="action-dropdown-wrapper">
                              <button
                                type="button"
                                className="action-menu-button"
                                onClick={(e) => {

                                  if (
                                    menuPosition?.row?.InvoiceGroupKey === row.InvoiceGroupKey
                                  ) {
                                    setMenuPosition(null);
                                    return;
                                  }

                                  const rect = e.currentTarget.getBoundingClientRect();

                                  setMenuPosition({
                                    row,
                                    top: rect.bottom + window.scrollY,
                                    left: rect.left + window.scrollX,
                                  });
                                }}
                              >
                                Actions ▼
                              </button>                          */}
                            {/* </div> */}
                          {/* </td> */}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="9">No invoices found in the checker Not found in MIGO queue.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          {menuPosition && (
            <div
                className="global-action-menu"
                style={{
                  position: "fixed",
                  top: menuPosition.top,
                  left: menuPosition.left,
                  zIndex: 999999,
                }}
              >
              <button
                type="button"
                onClick={() => {
                  handleAction(menuPosition.row, "approve");
                  setMenuPosition(null);
                }}
              >
                ✓ Approve
              </button>

              <button
                type="button"
                onClick={() => {
                  handleAction(menuPosition.row, "reject");
                  setMenuPosition(null);
                }}
              >
                ✕ Reject
              </button>

            </div>
          )}

          {approvalModal.open && (
              <div className="checker-invoicenum-approval-modal-overlay">

                  <div className="checker-invoicenum-approval-modal">

                      <div className="checker-invoicenum-approval-modal-header">

                          <h3>Checker Approval</h3>

                          <button
                              className="checker-invoicenum-modal-close"
                              onClick={() =>
                                  setApprovalModal({
                                      open:false,
                                      row:null,
                                      approvalData:{}
                                  })
                              }
                          >
                              ✕
                          </button>

                      </div>

                      <div className="checker-invoicenum-approval-info">

                          <p><strong>Vendor:</strong> {approvalModal.row?.VendorName}</p>

                          <p><strong>Invoice:</strong> {approvalModal.row?.InvNo}</p>

                      </div>

                      <table className="checker-invoicenum-approval-table">

                          <thead>

                              <tr>

                                  <th>Field</th>

                                  <th>OCR Value</th>

                                  <th>Updated Value</th>

                              </tr>

                          </thead>

                          <tbody>

                              {Object.entries(approvalModal.approvalData).map(([key,item])=>(
                                  <tr key={key}>

                                      <td>{item.label}</td>

                                      <td>{item.OCR || "-"}</td>

                                      <td>

                                          <input
                                              value={item.Updated || ""}
                                              onChange={(e)=>{

                                                  setApprovalModal(current=>{

                                                      const next=structuredClone(current);

                                                      next.approvalData[key].Updated=e.target.value;

                                                      return next;

                                                  });

                                              }}
                                          />

                                      </td>

                                  </tr>
                              ))}

                          </tbody>

                      </table>

                      <div className="checker-invoicenum-approval-footer">

                          <button
                              className="checker-invoicenum-reject-btn"
                              onClick={()=>handleAction(approvalModal,"reject")}
                          >
                              Reject
                          </button>

                          <button
                              className="checker-invoicenum-approve-btn"
                              onClick={()=>handleAction(approvalModal,"approve")}
                          >
                              Approve
                          </button>

                      </div>

                  </div>

              </div>
          )}
        </section>
    </CheckerViewShell>
  );
}
